/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Not_Enough_Balance_Gem_TitleInputs */

const en_dialog_not_enough_balance_gem_title = /** @type {(inputs: Dialog_Not_Enough_Balance_Gem_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not Enough Time Crystals`)
};

const ar_dialog_not_enough_balance_gem_title = /** @type {(inputs: Dialog_Not_Enough_Balance_Gem_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا يوجد ما يكفي من بلورات الزمن`)
};

const de_dialog_not_enough_balance_gem_title = /** @type {(inputs: Dialog_Not_Enough_Balance_Gem_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht genug Zeitkristalle`)
};

const es_dialog_not_enough_balance_gem_title = /** @type {(inputs: Dialog_Not_Enough_Balance_Gem_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No tienes suficientes Cristales de Tiempo`)
};

const fr_dialog_not_enough_balance_gem_title = /** @type {(inputs: Dialog_Not_Enough_Balance_Gem_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas assez de Cristaux Temporels`)
};

const it_dialog_not_enough_balance_gem_title = /** @type {(inputs: Dialog_Not_Enough_Balance_Gem_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non abbastanza Cristalli del Tempo`)
};

const ja_dialog_not_enough_balance_gem_title = /** @type {(inputs: Dialog_Not_Enough_Balance_Gem_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`時の結晶が不足しています`)
};

const ko_dialog_not_enough_balance_gem_title = /** @type {(inputs: Dialog_Not_Enough_Balance_Gem_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`타임 크리스탈이 부족해요`)
};

const pt_br_dialog_not_enough_balance_gem_title = /** @type {(inputs: Dialog_Not_Enough_Balance_Gem_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cristais do Tempo insuficientes`)
};

const ru_dialog_not_enough_balance_gem_title = /** @type {(inputs: Dialog_Not_Enough_Balance_Gem_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Недостаточно Кристаллов времени`)
};

const th_dialog_not_enough_balance_gem_title = /** @type {(inputs: Dialog_Not_Enough_Balance_Gem_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`มีคริสตัลแห่งกาลเวลาไม่เพียงพอ`)
};

const tr_dialog_not_enough_balance_gem_title = /** @type {(inputs: Dialog_Not_Enough_Balance_Gem_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yetersiz Zaman Kristali`)
};

const zh_cn_dialog_not_enough_balance_gem_title = /** @type {(inputs: Dialog_Not_Enough_Balance_Gem_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`时光宝石不够了`)
};

const zh_tw_dialog_not_enough_balance_gem_title = /** @type {(inputs: Dialog_Not_Enough_Balance_Gem_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`時光寶石不夠了`)
};

/**
* | output |
* | --- |
* | "Not Enough Time Crystals" |
*
* @param {Dialog_Not_Enough_Balance_Gem_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_not_enough_balance_gem_title = /** @type {((inputs?: Dialog_Not_Enough_Balance_Gem_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Not_Enough_Balance_Gem_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_not_enough_balance_gem_title(inputs)
	if (locale === "ar") return ar_dialog_not_enough_balance_gem_title(inputs)
	if (locale === "de") return de_dialog_not_enough_balance_gem_title(inputs)
	if (locale === "es") return es_dialog_not_enough_balance_gem_title(inputs)
	if (locale === "fr") return fr_dialog_not_enough_balance_gem_title(inputs)
	if (locale === "it") return it_dialog_not_enough_balance_gem_title(inputs)
	if (locale === "ja") return ja_dialog_not_enough_balance_gem_title(inputs)
	if (locale === "ko") return ko_dialog_not_enough_balance_gem_title(inputs)
	if (locale === "pt_br") return pt_br_dialog_not_enough_balance_gem_title(inputs)
	if (locale === "ru") return ru_dialog_not_enough_balance_gem_title(inputs)
	if (locale === "th") return th_dialog_not_enough_balance_gem_title(inputs)
	if (locale === "tr") return tr_dialog_not_enough_balance_gem_title(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_not_enough_balance_gem_title(inputs)
	return zh_tw_dialog_not_enough_balance_gem_title(inputs)
});